// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gradient-card_wrapper__ZbpHa"};